<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'storage-report.shop' | transloco }}</small>
              <hx-store-select [(ngModel)]="params.storeId" (selectChange)="onStoreChanged($event)"></hx-store-select>
            </div>

            <div class="filter">
              <small>{{ 'storage-report.data' | transloco }}</small>
              <hx-date-range-select [(ngModel)]="params.date" (selectChange)="applyFilters()"></hx-date-range-select>
            </div>

            <div class="filter">
              <small>{{ 'storage-report.products' | transloco }}</small>
              <hx-product-info-select [(ngModel)]="params.productInfoIds" [types]="selectedPITypes" [brandId]="brandId" [multiple]="true" [disabled]="!brandId" (selectChange)="applyFilters()"></hx-product-info-select>
            </div>

            <div class="filter">
              <small>{{ 'storage-report.category' | transloco }}</small>
              <hx-product-category-select [(ngModel)]="params.categoryIds" [multiple]="true" [brandId]="brandId"
                                          (selectChange)="applyFilters()"></hx-product-category-select>
            </div>
          </div>

          <button type="button" (click)="resetFilter()" class="btn btn-outline-primary m--margin-top-15">
            {{ 'reset.list' | transloco }}
          </button>

          <hr>

          <div class="block-table-scroll m_datatable m-datatable--fixed-col m-datatable m-datatable--default m-datatable--loaded m--margin-top-30 m--margin-bottom-30 is--fixed-column">
            <table *ngIf="list.length && list.length > 0 && !isLoading.list" class="m-datatable__table m-datatable__table--width">
              <thead class="m-datatable__head m-datatable__row">
              <tr class="fixed-head-oline m-datatable__row m-datatable__row--head">
                <th rowspan="4" class="text-nowrap fixed-head-one">
                  <span>{{ 'storage-report.products' | transloco }}</span>
                </th>
                <th rowspan="4" class="thcomponent" *ngFor="let date of formatData">
                  <span>{{ date | date: 'dd.MM.yyyy' }}</span>
                </th>
              </tr>
              </thead>
              <tbody class="m-datatable__body">
                <tr class="m-datatable__row" *ngFor="let even = even;let i = index; let productInfo of list"
                    [ngClass]="{ 'm-datatable__row--even': even }">
                  <td class="tbody-fixed-one m-datatable__cell m-datatable__cell--fixed-col">
                    {{ productInfo.productInfoTitle | uiLabel }}
                  </td>
                  <ng-container *ngFor="let date of formatData">
                    <td *ngIf="map.has(productInfo.productInfoId + '.' + date)" class="m-datatable__cell m-datatable__cell--fixed-col text-center">
                      <span [ngbTooltip]="map.get(productInfo.productInfoId + '.' + date).transferAmount + ' / ' + map.get(productInfo.productInfoId + '.' + date).discardAmount">
                        {{ map.get(productInfo.productInfoId + '.' + date).amount }}
                      </span>
                    </td>
                    <td *ngIf="!map.has(productInfo.productInfoId + '.' + date)" class="m-datatable__cell m-datatable__cell--fixed-col text-center">
                      0
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>

            <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
